import { Theme } from '@mui/material'

const useStyles = {
  container: {
    gap: 1,
    flexDirection: 'column' as const,
  },
  stickyHeader: (theme: Theme) => ({
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.ui.surfaceContainerLow,
  }),
  viewingHeader: {
    padding: 1,
    height: '56px',
    alignItems: 'center',
  },
  viewingText: {
    fontWeight: '500',
  },
  locationContainer: {
    paddingX: 1,
  },
  locationDetails: {
    gap: 0.5,
    flexDirection: 'column' as const,
  },
  addressText: {
    letterSpacing: '0.25px',
  },
  switchButton: {
    padding: 1,
    height: '56px',
    alignItems: 'center',
    paddingLeft: 2,
  },
}

export default useStyles
